// Copyright (c) 2017 TrainHeroic LLC
// Table tree is used to manage the state of all of the rTables / lists

import { getStore } from '../../store';
import ACTIONS from '../summary/actions';
import * as FeedService from '../../../api/service/feedService';

import * as ToastState from '../clipboard/toast';

export const clearPhotoPreview = () => {
    getStore().dispatch({
        type: ACTIONS.FEED_IMAGE_UPLOADED,
        imageUploaded: null
    });
};

export const createFeedItem = async (parentFeedId, newReply, feedCard) => {
    clearPhotoPreview();
    const reply = await FeedService.createFeedItem(parentFeedId, newReply);

    getStore().dispatch({
        type: ACTIONS.FEED_CARD_ADD_REPLY,
        feedCard,
        reply
    });
};

export const likeFeed = (feedItem, feedCardData) => {
    FeedService.like(feedItem.feed_id, feedItem.feed_item_id, feedItem.liked);
    if (feedItem.feed_item_id === feedCardData.feed_item_id) {
        getStore().dispatch({
            type: ACTIONS.FEED_CARD_LOAD,
            card: {
                ...feedCardData,
                liked: feedItem.liked
            }
        });
        getStore().dispatch({
            type: ACTIONS.FEED_ITEM_LIKE,
            feedItem
        });
    } else {
        for (let i = 0; i < feedCardData.replies.length; i++) {
            if (
                feedCardData.replies[i].feed_item_id === feedItem.feed_item_id
            ) {
                feedCardData.replies[i] = feedItem;
                getStore().dispatch({
                    type: ACTIONS.FEED_CARD_LOAD,
                    card: {
                        ...feedCardData,
                        replies: feedCardData.replies
                    }
                });
                getStore().dispatch({
                    type: ACTIONS.FEED_ITEM_LIKE,
                    feedItem: feedCardData
                });
                break;
            }
        }
    }
    getStore().dispatch({
        type: ACTIONS.FEED_ACTION,
        actionFeed: 'likeFeed'
    });
};

export const deleteFeed = (feedItem, feedCardData) => {
    FeedService.deleteFeedItem(feedItem.feed_id, feedItem.feed_item_id);
    const replies = [];
    for (let i = 0; i < feedCardData.replies.length; i++) {
        const reply = feedCardData.replies[i];
        if (reply.feed_item_id !== feedItem.feed_item_id) {
            replies.push(reply);
        }
    }
    getStore().dispatch({
        type: ACTIONS.FEED_ACTION,
        actionFeed: 'delete'
    });

    getStore().dispatch({
        type: ACTIONS.FEED_CARD_LOAD,
        card: {
            ...feedCardData,
            replies
        }
    });

    getStore().dispatch({
        type: ACTIONS.COMMENT_ADD_DELETE,
        card: {
            ...feedCardData,
            replies
        }
    });

    ToastState.showSuccessMessage('Reply Deleted');
};

export const uploadPhoto = async photoFile => {
    const response = await FeedService.uploadPhoto(photoFile);
    getStore().dispatch({
        type: ACTIONS.FEED_IMAGE_UPLOADED,
        imageUploaded: response
    });
    getStore().dispatch({
        type: ACTIONS.FEED_ACTION,
        actionFeed: 'uploadFile'
    });
};

export const getFeedCard = async feedItemId => {
    let response = null;
    if (feedItemId) {
        response = await FeedService.getFeedCard(feedItemId);
    } else {
        response = {
            data: {}
        };
    }
    const card = response.data;
    getStore().dispatch({
        type: ACTIONS.FEED_CARD_LOAD,
        card
    });
};

export const getFeedCardUsingProgramWorkoutIdAndTeamId = async (
    programWorkoutId,
    teamId
) => {
    const card = await FeedService.getFeedCardUsingProgramWorkoutIdAndTeamId(
        programWorkoutId,
        teamId
    );
    getStore().dispatch({
        type: ACTIONS.FEED_CARD_LOAD,
        card
    });
};
